// 日期格式化函數
const formatDateTime = (date, options = {}) => {
    const { showSeconds = true } = options;
    if (!date) {
        return null;
    }
    const d = new Date(date);
    // 檢查日期是否有效
    if (isNaN(d.getTime())) {
        return null;
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hour = String(d.getHours()).padStart(2, '0');
    const minute = String(d.getMinutes()).padStart(2, '0');
    const second = String(d.getSeconds()).padStart(2, '0');

    if (!showSeconds) {
        return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

export default formatDateTime;
